<template>
    <section class="fill-width fill-height">
        <div class="pos-absolute fs-20 text-center pos-center pb-22" style="z-index:2">
            <div class="mb-10">
                여행을 위한 모든 준비가<br>
                끝났습니다!
            </div>
            <div class="fw-600">지금 바로 여행이 시작됩니다.</div>
        </div>
         <v-img :src="getImage('background/desert/day.png')" width="100vw" height="calc(var(--vh, 1vh) * 100)" style="opacity:0.46"></v-img>
    </section>
</template>
<script>
import store from "@/store";
export default {
    components: {
    },
    created(){
        this.travelStart();
    },
    methods:{
        async travelStart(){
          await store.dispatch('getUseOrdDtl', true)
            setTimeout(() => {
            // Code here
                this.movePage('/')
            }, 2000);

        }
    }
}
</script>
